import { ImagesFeature } from "./features/ImagesFeature";

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-12 sm:py-16 bg-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <ImagesFeature />
      </div>
    </section>
  );
};
